import { Box, TableContainer } from '@mui/material';
import DataTable from '../../../../../components/DataTable/DataTable';
import { CONTRACTOR_BUSINESS_TYPES, contractorsTableColumnTitles } from '../consts';
import DeleteIcon from '@mui/icons-material/Delete';
import EyeIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import TableActionButton from '../../../../../components/DataTable/TableActionButton';
import { useAppSelector } from '../../../../../hooks/reduxHooks';
import { enqueueSnackbar } from 'notistack';

const ContractorsAccordionContent = ({
    contractors,
    translate,
    handleClickEditIcon,
    contractorsState,
    alerts,
    onlyVisual
}: any) => {
  const ciiuCodes = useAppSelector(
        (state) => state?.carcinogenicReport?.ciiuCodes
    );

    const selectedCarcinogenicReportId = useAppSelector(
        (state) => state?.carcinogenicReport?.selectedCarcinogenicReportId
    );

    const { deleteContractor } = contractorsState;

    const { showConfirmDeleteContractorAlert } = alerts;

    const handleDeleteContractor = async (contractorId: number) => {
        try {
            if(!contractorId || !selectedCarcinogenicReportId) return
            const response = await deleteContractor({
                reportId: selectedCarcinogenicReportId,
                contractorId: contractorId
            });
        } catch (error) {
            enqueueSnackbar(translate('enqueues.common.somethingWentWrong'), {
                variant: 'error'
            });
        }
    }

    const getCompanyActivityInfo = (activityId: number) => {
        if(!activityId) return '-'
        const companyActivity = ciiuCodes?.data?.codigos?.find((ciiuCode: any) => ciiuCode.id === activityId);
        if(!companyActivity) return '-';
        
        return `${companyActivity?.codigo || ''} - ${companyActivity?.descripcion || ''}`;
    };

    const getCompanyType = (companyTypeId: number) => {
        if(!companyTypeId) return '-'
        const companyType = CONTRACTOR_BUSINESS_TYPES?.find((companyType: any) => companyType.id === companyTypeId);
        if(!companyType) return '-';
        
        return `${companyType?.nombre || ''}`;
    };
    return (
        <>
            <TableContainer>
                <DataTable
                    // testID={TEST_IDS.table.id}
                    columnTitles={contractorsTableColumnTitles(translate)}
                    columnWidths={['20%', '30%', '20%', '20%', '5%']}
                    onSelectRow={() => {}}
                    // selected={selected}
                    selectedItemFromAction={null}
                    menuOpen={false}
                    items={{ data: { data: contractors } }}
                    loading={false}
                    filters={{ take: 1000, skip: 0 }}
                    setFilters={() => {}}
                    isFetching={false}
                    headers={[
                        {
                            type: 'data',
                            upperLabel: (item: any) => `${item?.cuit}`
                        },
                        {
                            type: 'data',
                            upperLabel: (item: any) =>
                                `${getCompanyActivityInfo(item?.idActividad)}`
                        },
                        {
                            type: 'data',
                            upperLabel: (item: any) => `${getCompanyType(item?.tipoEmpresa)}`
                        },
                        {
                            type: 'data',
                            upperLabel: (item: any) => `${item?.cantidadTrabajadores || '-'}`
                        },
                        {
                            type: 'data',
                            lowerLabel: (item: any) => (
                                <Box display={'flex'} gap={1.5}>
                                    {!onlyVisual && (
                                        <TableActionButton
                                            disabled={false}
                                            onClick={() =>
                                                showConfirmDeleteContractorAlert({
                                                    confirmAction: () =>
                                                        handleDeleteContractor(item?.id)
                                                })
                                            }
                                            IconComponent={DeleteIcon}
                                        />
                                    )}
                                    <TableActionButton
                                        disabled={false}
                                        onClick={() => handleClickEditIcon(item)}
                                        IconComponent={!onlyVisual ? EditIcon : EyeIcon}
                                    />
                                </Box>
                            )
                        }
                    ]}
                />
            </TableContainer>
        </>
    );
};

export { ContractorsAccordionContent };
